import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import api from '@/lib/api';
import type { TemplateKind } from '@/types';
import QuoteEditorPage from './QuoteEditorPage';

/**
 * Een template bewerk je in de gewone editor, via een werkkopie. Openen hergebruikt
 * een openstaande werkkopie, dus vernieuwen of later terugkomen gaat verder waar je was.
 */
function TemplateEditorPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [draft, setDraft] = useState<{ templateId: string; quoteId: string; kind: TemplateKind } | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!id) return;
    let cancelled = false;
    setFailed(false);
    api
      .openTemplateDraft(id)
      .then((quote) => {
        if (!cancelled) setDraft({ templateId: id, quoteId: quote.id, kind: quote.templateKind });
      })
      .catch(() => {
        if (!cancelled) setFailed(true);
      });
    return () => {
      cancelled = true;
    };
  }, [id]);

  if (failed) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-3 bg-neutral-100">
        <h2 className="text-lg font-semibold">Template openen mislukt</h2>
        <p className="text-sm text-muted-foreground">De template bestaat niet meer of je hebt er geen toegang toe.</p>
        <Button variant="outline" onClick={() => navigate('/?tab=templates')}>
          Terug naar templates
        </Button>
      </div>
    );
  }

  if (!draft || draft.templateId !== id) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-neutral-100">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  return <QuoteEditorPage quoteId={draft.quoteId} templateKind={draft.kind} />;
}

export default TemplateEditorPage;
